  /* ===== CW Predictive Search controller (vanilla JS, IIFE + double-init guard) ===== */
  (function () {
    if (window.__CW_SEARCH_INIT__) return;
    window.__CW_SEARCH_INIT__ = true;

    function init() {
      var root = document.querySelector('[data-cw-search]');
      var trigger = document.querySelector('[data-cw-search-open]');
      if (!root || !trigger) return;

      var panel = root.querySelector('[data-cw-search-panel]');
      var input = root.querySelector('[data-cw-search-input]');
      var results = root.querySelector('[data-cw-search-results]');

      var lastFocused = null;
      var controller = null;
      var debounceTimer = null;

      function isOpen() {
        return document.body.classList.contains('cw-search-open');
      }

      function openSearch() {
        if (isOpen()) return;
        lastFocused = document.activeElement;
        document.body.classList.add('cw-search-open');
        root.setAttribute('aria-hidden', 'false');
        window.setTimeout(function () {
          try { input.focus(); input.select(); } catch (e) {}
        }, 60);
      }

      function clearResults() {
        results.innerHTML = '';
        results.classList.remove('is-visible');
      }

      function closeSearch() {
        if (!isOpen()) return;
        document.body.classList.remove('cw-search-open');
        root.setAttribute('aria-hidden', 'true');
        if (controller) { try { controller.abort(); } catch (e) {} controller = null; }
        window.clearTimeout(debounceTimer);
        clearResults();
        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus(); } catch (e) {}
        }
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen()) { closeSearch(); } else { openSearch(); }
      });

      /* Close on X click or backdrop click (both carry data-cw-search-close). */
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-cw-search-close]')) {
          e.preventDefault();
          closeSearch();
        }
      });

      /* Escape closes. */
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) {
          closeSearch();
        }
      });

      /* Lightweight focus trap within the dialog. */
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !isOpen()) return;
        var nodes = panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
        var focusables = Array.prototype.filter.call(nodes, function (el) {
          return !el.disabled && el.offsetParent !== null;
        });
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      function formatPrice(price) {
        if (price == null || price === '') return '';
        var s = String(price).trim();
        /* Predictive-search price format varies by shop: already money-formatted ("$379.00"),
           a decimal string ("379.00"), or an integer in cents ("37900"). Handle all three. */
        if (/[^\d.,\s]/.test(s)) { return s; }                  /* has a currency symbol/letters -> show as-is */
        if (s.indexOf('.') !== -1) {                            /* major-units decimal string */
          var d = parseFloat(s); return isNaN(d) ? '' : '$' + d.toFixed(2);
        }
        var c = parseInt(s, 10);                                /* plain integer -> treat as cents */
        return isNaN(c) ? '' : '$' + (c / 100).toFixed(2);
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function render(products) {
        if (!products || !products.length) {
          results.innerHTML = '<p class="cw-search__empty">' + cwT('No results') + '</p>';
          results.classList.add('is-visible');
          return;
        }
        var html = '';
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          var img = p.image || p.featured_image || '';
          var thumb = img
            ? '<img class="cw-search__thumb" src="' + escapeHtml(img) + '" alt="" loading="lazy" width="52" height="52">'
            : '<span class="cw-search__thumb cw-search__thumb--empty" aria-hidden="true"></span>';
          html += '<a class="cw-search__result" href="' + escapeHtml(p.url) + '">' +
            thumb +
            '<span class="cw-search__result-info">' +
              '<span class="cw-search__result-title">' + escapeHtml(p.title) + '</span>' +
            '</span>' +
          '</a>';
        }
        results.innerHTML = html;
        results.classList.add('is-visible');
      }

      function fetchSuggest(q) {
        if (controller) { try { controller.abort(); } catch (e) {} }
        controller = ('AbortController' in window) ? new AbortController() : null;
        var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            render(products);
          })
          .catch(function (err) {
            /* Ignore aborted (stale) and failed requests. */
            if (err && err.name === 'AbortError') return;
          });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        window.clearTimeout(debounceTimer);
        if (controller) { try { controller.abort(); } catch (e) {} controller = null; }
        if (q.length < 2) {
          clearResults();
          return;
        }
        debounceTimer = window.setTimeout(function () {
          fetchSuggest(q);
        }, 200);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
      /* Express-wallet policy: at most three wallets, Shop Pay, the device's native wallet
         (Apple Pay on Apple-Pay devices, Google Pay elsewhere), and PayPal (it converts).
         The one hard exclusion is the non-native wallet (Google Pay on Apple-Pay/iOS devices),
         which is what previously stacked the row four buttons tall. /checkout always keeps
         every method.

         WHY attribute filtering, not CSS: <shopify-accelerated-checkout-cart> builds exactly
         one button per entry of its `wallet-configs` attribute and reads that attribute ONLY
         when it hydrates (`wallet-configs` is not in its observedAttributes). Hiding a rendered
         button just empties the slot Shopify reserved for it inside the component, leaving a
         dead gap, the failure mode of the previous attempt. Filtering the JSON BEFORE
         hydration means the unwanted buttons are never created at all. This runs (1) here at
         parse time for the server-rendered drawer, ahead of Shopify's DOMContentLoaded
         bootstrap, and (2) from cw-cart.js on the detached fragment before every drawer swap.

         Fail-open: any parsing surprise (e.g. Shopify changes the attribute format) leaves the
         attribute untouched, so the worst case is all wallets rendering like before, never a
         broken express checkout. */
      (function () {
        'use strict';

        var SELECTOR = 'shopify-accelerated-checkout-cart[wallet-configs]';

        /* Wallets in preference order; the first THREE that exist in the session's configs
           win. Google Pay is deliberately absent from the Apple lists, that exclusion is
           what keeps the row from ever stacking four buttons tall again. */
        function rankedWallets() {
          var isApple = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
          var canApplePay = false;
          try { canApplePay = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) {}
          if (canApplePay) return ['shop_pay', 'apple_pay', 'paypal'];
          /* Apple hardware without usable Apple Pay still must not fall back to Google Pay. */
          if (isApple) return ['shop_pay', 'paypal'];
          return ['shop_pay', 'google_pay', 'paypal'];
        }

        function filterComponent(el) {
          try {
            var configs = JSON.parse(el.getAttribute('wallet-configs'));
            if (!Array.isArray(configs)) return;
            var ranked = rankedWallets();
            var byName = {};
            for (var n = 0; n < configs.length; n++) {
              if (configs[n] && !byName[configs[n].name]) byName[configs[n].name] = configs[n];
            }
            var kept = [];
            for (var r = 0; r < ranked.length && kept.length < 3; r++) {
              if (byName[ranked[r]]) kept.push(byName[ranked[r]]);
            }
            var next = JSON.stringify(kept);
            if (next !== el.getAttribute('wallet-configs')) el.setAttribute('wallet-configs', next);
            /* Trim surplus skeleton placeholders so the pre-hydration flash already shows the
               final button count. After hydration these cells no longer exist, so this no-ops. */
            var cells = el.querySelectorAll('.wallet-cart-button-container');
            for (var i = cells.length - 1; i >= kept.length; i--) cells[i].parentNode.removeChild(cells[i]);
            /* No wallet survived the policy: drop the whole express block, divider included. */
            if (!kept.length && el.closest) {
              var wrap = el.closest('.cw-cart-drawer__express');
              if (wrap) wrap.hidden = true;
            }
          } catch (e) { /* fail open */ }
        }

        function apply(root) {
          var scope = root || document;
          if (scope.nodeType === 1 && scope.matches && scope.matches(SELECTOR)) filterComponent(scope);
          if (scope.querySelectorAll) {
            var found = scope.querySelectorAll(SELECTOR);
            for (var i = 0; i < found.length; i++) filterComponent(found[i]);
          }
        }

        window.CWWalletPolicy = { apply: apply };

        /* Server-rendered drawer: this script sits after the drawer markup and runs during
           parse, before the DOMContentLoaded bootstrap hydrates the component. */
        apply(document);

        /* Safety net for inserts that bypass cw-cart.js's pre-swap hook. Only effective while
           the element has not hydrated yet (attribute changes are ignored afterwards), which
           is exactly the risky window. */
        new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              if (added[j].nodeType === 1) apply(added[j]);
            }
          }
        }).observe(document.documentElement, { childList: true, subtree: true });
      })();
    
  /* BALANCED CART OPEN GUARD:
     Cart stays open during cart interactions on the same page,
     but never auto-opens when navigating to a new page. */
  (function() {
    window.CWUseFinalCartControllerOnly = true;
    window.__CW_CART_INTERACTION_ACTIVE__ = false;

    try {
      sessionStorage.removeItem('cw_cart_should_open');
      sessionStorage.removeItem('cw_cart_open');
      localStorage.removeItem('cw_cart_should_open');
      localStorage.removeItem('cw_cart_open');
    } catch (e) {}

    /* Earliest close: prevents page-navigation cart flash. */
    document.body.classList.remove('cw-cart-open');

    function allowCartOpenForCurrentInteraction() {
      window.__CW_CART_INTERACTION_ACTIVE__ = true;
      window.clearTimeout(window.__CW_CART_INTERACTION_TIMER__);
      window.__CW_CART_INTERACTION_TIMER__ = window.setTimeout(function() {
        window.__CW_CART_INTERACTION_ACTIVE__ = false;
      }, 8000);
    }

    function guardedOpenCart() {
      if (window.__CW_CART_INTERACTION_ACTIVE__) {
        document.body.classList.add('cw-cart-open');
      }
    }

    function closeCart() {
      window.__CW_CART_INTERACTION_ACTIVE__ = false;
      document.body.classList.remove('cw-cart-open');
    }

    if (!window.CWUseFinalCartControllerOnly) {
      /* Capture actual user intent before older scripts run. */
      document.addEventListener('click', function(event) {
        if (event.target.closest('[data-cw-cart-open]') || event.target.closest('[data-cw-cart-change]')) {
          allowCartOpenForCurrentInteraction();
        }

        if (event.target.closest('[data-cw-cart-close]')) {
          event.preventDefault();
          closeCart();
        }
      }, true);

      document.addEventListener('submit', function(event) {
        if (event.target && event.target.matches('form[action*="/cart/add"]')) {
          allowCartOpenForCurrentInteraction();
        }
      }, true);
    }

    /* After the page is fully ready, make sure normal navigation never leaves cart open. */
    function closeIfNoInteraction() {
      if (!window.__CW_CART_INTERACTION_ACTIVE__) {
        document.body.classList.remove('cw-cart-open');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', closeIfNoInteraction);
    } else {
      closeIfNoInteraction();
    }

    window.addEventListener('pageshow', closeIfNoInteraction);

    /* Expose safe helpers for later scripts in this file. */
    window.CWAllowCartOpenForCurrentInteraction = allowCartOpenForCurrentInteraction;
    window.CWGuardedOpenCart = guardedOpenCart;
    window.CWGuardedCloseCart = closeCart;
  })();
  (function() {
    function initCWHeaderScroll() {
      var header = document.querySelector('[data-cw-header]');
      var spacer = document.querySelector('[data-cw-header-spacer]');
      var announcement = document.querySelector('[data-cw-announcement]');

      if (!header) return;

      var lastScrollY = window.scrollY || 0;
      var ticking = false;

      function setHeights() {
        var announcementHeight = announcement ? Math.round(announcement.getBoundingClientRect().height) : 38;
        var headerHeight = Math.round(header.getBoundingClientRect().height) || 74;
        var stackHeight = announcementHeight + headerHeight;

        document.documentElement.style.setProperty('--cw-announcement-height', announcementHeight + 'px');
        document.documentElement.style.setProperty('--cw-header-height', headerHeight + 'px');
        document.documentElement.style.setProperty('--cw-fixed-header-stack-height', stackHeight + 'px');

        if (spacer) {
          spacer.style.height = stackHeight + 'px';
          spacer.style.minHeight = stackHeight + 'px';
        }
      }

      function showAtTop() {
        header.classList.remove('cw-header--hidden', 'cw-header--returned');
        header.classList.add('cw-header--top');
      }

      function showReturned() {
        header.classList.remove('cw-header--hidden', 'cw-header--top');
        header.classList.add('cw-header--returned');
      }

      function hideHeader() {
        header.classList.add('cw-header--hidden');
        header.classList.remove('cw-header--returned', 'cw-header--top');
      }

      function update() {
        var currentY = window.scrollY || 0;
        var diff = currentY - lastScrollY;

        if (currentY <= 12) {
          showAtTop();
        } else if (diff > 6) {
          hideHeader();
        } else if (diff < -6) {
          showReturned();
        }

        if (Math.abs(diff) > 6) {
          lastScrollY = currentY;
        }

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      function refreshHeaderLayout() {
        setHeights();
        update();
      }

      refreshHeaderLayout();
      window.requestAnimationFrame(refreshHeaderLayout);
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(refreshHeaderLayout);
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', refreshHeaderLayout, { once: true });
      }

      window.addEventListener('load', refreshHeaderLayout, { once: true });
      window.addEventListener('pageshow', refreshHeaderLayout);
      window.addEventListener('resize', refreshHeaderLayout, { passive: true });

      window.addEventListener('scroll', onScroll, { passive: true });

      document.addEventListener('shopify:section:load', function() {
        setTimeout(refreshHeaderLayout, 50);
      });
    }

    initCWHeaderScroll();
  })();
  (function() {
    function initCWDrawerSubmenus() {
      var drawer = document.querySelector('.cw-drawer');
      if (!drawer || drawer.dataset.cwSubmenuReady === 'true') return;

      drawer.dataset.cwSubmenuReady = 'true';

      var nav = drawer.querySelector('[data-cw-drawer-nav]');
      var openButtons = drawer.querySelectorAll('[data-cw-submenu-open]');
      var backButtons = drawer.querySelectorAll('[data-cw-submenu-back]');
      var submenus = drawer.querySelectorAll('[data-cw-submenu]');
      var closeButtons = document.querySelectorAll('[data-cw-drawer-close]');
      var drawerOpenButtons = document.querySelectorAll('[data-cw-drawer-open]');

      function closeSubmenus() {
        drawer.classList.remove('has-active-submenu');
        if (nav) nav.classList.remove('is-submenu-open');

        submenus.forEach(function(submenu) {
          submenu.classList.remove('is-active');
          window.setTimeout(function() {
            if (!submenu.classList.contains('is-active')) {
              submenu.hidden = true;
            }
          }, 220);
        });
      }

      function openSubmenu(name) {
        var target = drawer.querySelector('[data-cw-submenu="' + name + '"]');
        if (!target) return;

        submenus.forEach(function(submenu) {
          submenu.classList.remove('is-active');
          submenu.hidden = true;
        });

        drawer.classList.add('has-active-submenu');
        if (nav) nav.classList.add('is-submenu-open');

        target.hidden = false;
        void target.offsetWidth;
        target.classList.add('is-active');
      }

      openButtons.forEach(function(button) {
        button.addEventListener('click', function(event) {
          event.preventDefault();
          openSubmenu(button.getAttribute('data-cw-submenu-open'));
        });
      });

      backButtons.forEach(function(button) {
        button.addEventListener('click', function(event) {
          event.preventDefault();
          closeSubmenus();
        });
      });

      closeButtons.forEach(function(button) {
        button.addEventListener('click', closeSubmenus);
      });

      drawerOpenButtons.forEach(function(button) {
        button.addEventListener('click', closeSubmenus);
      });
    }

    initCWDrawerSubmenus();

    document.addEventListener('shopify:section:load', function() {
      document.querySelectorAll('.cw-drawer').forEach(function(drawer) {
        drawer.dataset.cwSubmenuReady = 'false';
      });
      initCWDrawerSubmenus();
    });
  })();
  /* Disabled duplicate free-gift auto-add. The enhanced watch-only gift flow below handles gifts. */
  /* CW localization desktop + mobile one-click fix */
  (function() {
    if (window.__cwLocalizationDesktopFix) return;
    window.__cwLocalizationDesktopFix = true;

    var isSubmittingLocalization = false;

    function submitExistingLocalizationForm(button, inputSelector, inputName, value) {
      if (!button || !value || isSubmittingLocalization) return;

      var form = button.closest('form');
      if (!form) return;

      var input = form.querySelector(inputSelector);

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        form.appendChild(input);
      }

      /* If the selected option is already active, just close the dropdown. */
      if (String(input.value || '').toLowerCase() === String(value || '').toLowerCase()) {
        var sameDetails = button.closest('details');
        if (sameDetails) sameDetails.open = false;
        return;
      }

      isSubmittingLocalization = true;
      input.value = value;

      var returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) {
        returnTo.value = window.location.pathname + window.location.search;
      }

      var details = button.closest('details');
      if (details) details.open = false;

      document.documentElement.classList.add('cw-localization-loading');

      /*
        IMPORTANT:
        This must submit Shopify's native localization form.
        Do not call refreshCartDrawer() here, that only redraws the cart and leaves
        the localization form stuck in a loading state without changing currency/market.
      */
      window.setTimeout(function() {
        HTMLFormElement.prototype.submit.call(form);
      }, 20);
    }

    function handleLocalizationEvent(event) {
      var countryButton = event.target.closest('[data-cw-country-code]');
      if (countryButton) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        submitExistingLocalizationForm(
          countryButton,
          '[data-cw-country-input], input[name="country_code"]',
          'country_code',
          countryButton.getAttribute('data-cw-country-code')
        );

        return;
      }

      var languageButton = event.target.closest('[data-cw-language-code]');
      if (languageButton) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        submitExistingLocalizationForm(
          languageButton,
          '[data-cw-language-input], input[name="language_code"]',
          'language_code',
          languageButton.getAttribute('data-cw-language-code')
        );
      }
    }

    /*
      Use click only. Earlier versions used pointerdown + click, which could double-fire
      and conflict with the cart AJAX patches.
    */
    document.addEventListener('click', handleLocalizationEvent, true);

    window.addEventListener('pageshow', function() {
      document.documentElement.classList.remove('cw-localization-loading');
      isSubmittingLocalization = false;
    });
  })();
  (function() {
    function initCWCartOfferCarousel() {
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (!drawer) return;

      var offers = Array.prototype.slice.call(drawer.querySelectorAll('[data-cw-cart-offer-slide]')).slice(0, 5);
      var dots = Array.prototype.slice.call(drawer.querySelectorAll('[data-cw-cart-offer-dot]'));

      if (!offers.length) {
        var offerWrap = drawer.querySelector('.cw-cart-offers');
        if (offerWrap) offerWrap.style.display = 'none';
        return;
      }

      function setActive(index) {
        if (index < 0 || index >= offers.length) index = 0;

        offers.forEach(function(offer, offerIndex) {
          offer.classList.toggle('is-active', offerIndex === index);
        });

        dots.forEach(function(dot, dotIndex) {
          var usable = dotIndex < offers.length;
          dot.hidden = !usable;
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(event) {
          event.preventDefault();
          setActive(Number(dot.getAttribute('data-cw-cart-offer-dot')) || 0);
        });
      });

      Array.prototype.slice.call(drawer.querySelectorAll('[data-cw-cart-offer-slide]')).forEach(function(offer, index) {
        if (index >= 5) offer.remove();
      });

      setActive(0);
    }

    initCWCartOfferCarousel();

    document.addEventListener('shopify:section:load', function() {
      setTimeout(initCWCartOfferCarousel, 50);
    });
  })();
  (function() {
    if (window.CWCartFooterCountdownReady) return;
    window.CWCartFooterCountdownReady = true;

    var remaining = 300;
    var intervalId = null;
    var wasOpen = document.body.classList.contains('cw-cart-open');

    function getTimerTarget() {
      return document.querySelector('.cw-cart-drawer__timer--premium b');
    }

    function format(seconds) {
      var minutes = Math.floor(seconds / 60);
      var rest = seconds % 60;
      return String(minutes).padStart(2, '0') + ':' + String(rest).padStart(2, '0');
    }

    function render() {
      var target = getTimerTarget();
      if (target) target.textContent = format(remaining);
    }

    function stop() {
      window.clearInterval(intervalId);
      intervalId = null;
    }

    function start(reset) {
      if (reset) remaining = 300;
      render();
      stop();
      intervalId = window.setInterval(function() {
        if (remaining > 0) remaining -= 1;
        render();
        if (remaining <= 0) stop();
      }, 1000);
    }

    function syncState() {
      var isOpen = document.body.classList.contains('cw-cart-open');
      if (isOpen && !wasOpen) {
        start(true);
      } else if (!isOpen && wasOpen) {
        stop();
      } else if (isOpen) {
        render();
        if (!intervalId && remaining > 0) start(false);
      }
      wasOpen = isOpen;
    }

    document.addEventListener('click', function(event) {
      if (event.target.closest('[data-cw-cart-open], [data-cw-cart-close]')) {
        window.setTimeout(syncState, 30);
      }
    }, true);

    var observer = new MutationObserver(syncState);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (wasOpen) start(true);
    else render();
  })();
  (function() {
    if (window.CWCartPromoDismissReady) return;
    window.CWCartPromoDismissReady = true;

    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-cw-cart-promo-close]');
      if (!button) return;

      event.preventDefault();
      var promo = button.closest('[data-cw-cart-promo]');
      if (promo) promo.hidden = true;
    });
  })();

/* Drawer images load on first open, not on page load. The drawer sits just off
   canvas, so the browser used to fetch the six Popular collections tiles (168 KB)
   on every page even though nobody had opened the menu. */
(function () {
  if (window.__cwDrawerImagesReady) return;
  window.__cwDrawerImagesReady = true;
  var hydrate = function () {
    var imgs = document.querySelectorAll('img[data-cw-drawer-img]');
    if (!imgs.length) return;
    Array.prototype.forEach.call(imgs, function (img) {
      img.src = img.getAttribute('data-cw-drawer-img');
      img.removeAttribute('data-cw-drawer-img');
    });
  };
  document.addEventListener('click', function (event) {
    var opener = event.target && event.target.closest ? event.target.closest('[data-cw-drawer-open]') : null;
    if (opener) hydrate();
  }, { capture: true, passive: true });
  /* Safety net: if the drawer is opened some other way, hydrate then. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (document.documentElement.classList.contains('cw-drawer-open')) hydrate();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
})();
